export const breakpoints = {
  sm: { value: '320px' },
  md: { value: '768px' },
  lg: { value: '960px' },
  xl: { value: '1200px' },
  '2xl': { value: '1600px' },
};
